import { Button, Form, Input, Select } from 'antd';
import React, { useState } from 'react';

const { Option } = Select;
const NumberInput = ({ value = {}, onChange, inputClass }) => {
    const [number, setNumber] = useState('');
    const triggerChange = (changedValue) => {
        onChange?.({
            number,
            ...value,
            ...changedValue,
        });
    };
    const onNumberChange = (e) => {
        const newNumber = e.target.value;
        const regex = new RegExp(/^[0-9]*$/);
        const check = regex.test(newNumber);

        console.log(check);

        // if (check == true) {
        //     setNumber(newNumber);
        // }
        // if (Number.isNaN(number) || newNumber.length > 10) {
        //     return;
        // }
        // if (regex.test(newNumber)) {
        //     setNumber(newNumber);
        // }
        if (check == true) {
            triggerChange({
                number: newNumber,
            });
            setNumber(newNumber);
        } else return;
    };
    return (
        <span>
            <Input
                style={{ padding: '10px' }}
                className={inputClass}
                placeholder="Phone number"
                type="text"
                maxLength={10}
                value={value.number || number}
                onChange={onNumberChange}
            />
        </span>
    );
};

export default NumberInput;
